import { otherDiscountsSuppressed } from '../lib/promotions';

// Generate 15-minute interval time slots from 6:00 to 22:00
export const TIME_SLOTS = [];
for (let h = 6; h <= 21; h++) {
  for (let m = 0; m < 60; m += 15) {
    const hh = h.toString().padStart(2, '0');
    const mm = m.toString().padStart(2, '0');
    const val = `${hh}:${mm}`;
    const label = `${h > 12 ? h - 12 : h}:${mm} ${h >= 12 ? 'PM' : 'AM'}`;
    TIME_SLOTS.push({ value: val, label });
  }
}
// Add 22:00 as last slot
TIME_SLOTS.push({ value: '22:00', label: '10:00 PM' });

// Calculate duration in hours from HH:MM strings
export const calcDurationHours = (start, end) => {
  if (!start || !end) return 0;
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  return (eh * 60 + em - sh * 60 - sm) / 60;
};

// Get auto-discount percent based on duration (off while a sale promotion
// suppresses other discounts — mirrors backend calc_auto_discount_percent)
export const getAutoDiscount = (hours) => {
  if (otherDiscountsSuppressed()) return { percent: 0, label: '' };
  if (hours >= 9) return { percent: 20, label: 'Full Day Discount (20%)' };
  if (hours >= 4.5) return { percent: 10, label: 'Half Day Discount (10%)' };
  return { percent: 0, label: '' };
};

// 10% off 5+ Day Passes — mirrors backend bulk_day_pass_discount_pct
export const isBulkDayPassDiscount = (passQty) =>
  !otherDiscountsSuppressed() && (parseInt(passQty) || 1) >= 5;

// Filter end time slots to be at least 1 hour after start
export const getEndSlots = (startTime) => {
  if (!startTime) return TIME_SLOTS;
  const [sh, sm] = startTime.split(':').map(Number);
  const minEnd = sh * 60 + sm + 60; // at least 1 hour after start
  return TIME_SLOTS.filter(s => {
    const [h, m] = s.value.split(':').map(Number);
    return h * 60 + m >= minEnd;
  });
};
